import { useState, useEffect } from "react";
import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { Button, InputNumber, Input } from "antd";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const COLOR = "#3b82f6";

const DripNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();

  // Local state for message only — prevents focus loss on every keystroke (same pattern as ActionNode)
  const [message, setMessage] = useState(data.message || "");
  useEffect(() => { setMessage(data.message || ""); }, [data.message]);

  const update = (patch) => data.onChange?.({ ...data, ...patch });

  const totalMins = (data.days || 0) * 24 * 60 + (data.hours || 0) * 60 + (data.minutes || 0);

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? COLOR : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color={COLOR} />
      <Handle type="target" position={Position.Left} style={{ background: COLOR }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 16 }}>⏳</span>
        <strong style={{ fontSize: 13 }}>Drip Message</strong>
        <Button type="text" size="small" icon={<CopyOutlined />}
          onClick={() => data.onDuplicate?.()}
          style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />}
          onClick={() => deleteElements({ nodes: [{ id }] })}
          style={{ color: "#9ca3af" }} />
      </div>

      <div className="nodrag" onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <NodeNameInput data={data} />
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4 }}>Send after</div>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <InputNumber
              value={data.days ?? 0}
              onChange={(v) => update({ days: v ?? 0 })}
              min={0} size="small" style={{ width: 56 }}
              addonAfter={<span style={{ fontSize: 10 }}>d</span>}
            />
            <InputNumber
              value={data.hours ?? 0}
              onChange={(v) => update({ hours: v ?? 0 })}
              min={0} max={23} size="small" style={{ width: 56 }}
              addonAfter={<span style={{ fontSize: 10 }}>h</span>}
            />
            <InputNumber
              value={data.minutes ?? 0}
              onChange={(v) => update({ minutes: v ?? 0 })}
              min={0} max={59} size="small" style={{ width: 56 }}
              addonAfter={<span style={{ fontSize: 10 }}>m</span>}
            />
          </div>
          {totalMins > 0 && (
            <div style={{ fontSize: 10, color: "#6b7280", marginTop: 3 }}>
              = {totalMins < 60 ? `${totalMins} min` : totalMins < 1440 ? `${(totalMins / 60).toFixed(1)} hours` : `${(totalMins / 1440).toFixed(1)} days`}
            </div>
          )}
        </div>

        <div style={{ marginBottom: 4 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Message to send</div>
          <Input.TextArea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onBlur={(e) => update({ message: e.target.value })}
            rows={3}
            size="small"
            placeholder="Hello {{firstname}}, following up on your enquiry..."
          />
          <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 2 }}>
            Supports {"{{firstname}}"}, {"{{lastname}}"}, custom vars
          </div>
        </div>

      </div>

      <Handle type="source" position={Position.Right} style={{ background: COLOR }} />
    </div>
  );
};

export default DripNode;
